import { DataQualityGrade } from '@lune-climate/lune'
import { DataQualityOverallScores } from '@lune-fe/dapi-models'
import { DataQualityScoreWithLabel } from '@lune-fe/lune-components-lib'
import { LuneThemeNew, Text } from '@lune-fe/lune-ui-lib'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { Box, Link } from '@mui/material'
import { FC } from 'react'

const { palette } = LuneThemeNew

const OverallScores: FC<{ data: DataQualityOverallScores }> = ({ data }) => {
    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    gap: 5,
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <DataQualityScoreWithLabel
                    empty={data.overallScore === null}
                    // the fallback score will not show, empty state will hande it
                    score={data.overallScore?.score as DataQualityGrade}
                    size={'lg'}
                    extraLabel={'All calculations'}
                />
                <Box
                    sx={{
                        display: 'flex',
                        gap: 5,
                        flexDirection: 'row',
                        width: '100%',
                    }}
                >
                    <DataQualityScoreWithLabel
                        empty={data.shippedOverallScore === null}
                        // the fallback score will not show, empty state will hande it
                        score={data.shippedOverallScore?.score as DataQualityGrade}
                        size={'md'}
                        extraLabel={'Shipment'}
                    />
                    <DataQualityScoreWithLabel
                        empty={data.notShippedOverallScore === null}
                        // the fallback score will not show, empty state will hande it
                        score={data.notShippedOverallScore?.score as DataQualityGrade}
                        size={'md'}
                        extraLabel={'Pre-shipment'}
                    />
                </Box>
            </Box>

            <Box>
                <Text variant={'body2'} sx={{ color: palette.Grey600, mb: 3 }}>
                    Your data health score reflects the quality and completeness of your data over
                    the last 3 months.
                    <br />
                    Higher scores indicate stronger, more reliable data.
                </Text>

                <Link
                    href={
                        'https://docs.lune.co/track-and-report-emissions/logistics/data-quality-score'
                    }
                    target={'_blank'}
                    sx={{
                        color: palette.Grey900,
                        textDecorationColor: palette.Grey900,
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Text variant={'body3'} sx={{ fontWeight: 500, mr: 1 }}>
                        Learn how we calculate your scores
                    </Text>
                    <OpenInNewIcon width={24} height={24} />
                </Link>
            </Box>
        </>
    )
}

export default OverallScores
